import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Room from '../views/Room.vue'
import Pregame from '../views/PregameScreen.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/:Room',
    name: 'Room',
    component: Room
  },
  {
    path: '/Pregame',
    name: 'Pregame',
    component: Pregame
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
